import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../../lib/api";

export const inputCls =
  "w-full border border-border rounded-sm px-3 py-2.5 text-[15px] bg-white focus:outline-none focus:ring-2 focus:ring-emerald/40";

export const money = (n) =>
  `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function Field({ label, children }) {
  return (
    <div>
      <label className="block text-sm font-600 text-charcoal/80 mb-1.5">{label}</label>
      {children}
    </div>
  );
}

export function Modal({ title, onClose, children, testid }) {
  return (
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-start justify-center p-4 overflow-y-auto" onClick={onClose} data-testid={testid}>
      <div className="bg-white rounded-sm w-full max-w-lg my-10 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-border">
          <h3 className="font-display text-xl font-600 text-charcoal">{title}</h3>
          <button onClick={onClose} className="text-charcoal/60 hover:text-charcoal" data-testid="modal-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="p-6 space-y-4">{children}</div>
      </div>
    </div>
  );
}

// Fetch customers + employees once for dropdowns.
export function useDirectory() {
  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);
  useEffect(() => {
    api.get("/users?role=customer").then(({ data }) => setCustomers(data)).catch(() => {});
    api.get("/users?role=employee").then(({ data }) => setEmployees(data)).catch(() => {});
  }, []);
  const nameOf = (list, id) => {
    const u = list.find((x) => x.id === id);
    return u ? (u.name || u.email) : "—";
  };
  return { customers, employees, custName: (id) => nameOf(customers, id), empName: (id) => nameOf(employees, id) };
}

const STATUS_STYLES = {
  unpaid: "bg-gold/15 text-gold-dark", overdue: "bg-red-100 text-red-700",
  paid: "bg-emerald/10 text-emerald", scheduled: "bg-gold/15 text-gold-dark",
  completed: "bg-emerald/10 text-emerald", draft: "bg-charcoal/10 text-charcoal/70",
  sent: "bg-gold/15 text-gold-dark", approved: "bg-emerald/10 text-emerald",
  declined: "bg-red-100 text-red-700", new: "bg-gold/15 text-gold-dark",
};

export function Pill({ status }) {
  return <span className={`text-xs font-600 px-2.5 py-1 rounded-sm capitalize ${STATUS_STYLES[status] || "bg-charcoal/10 text-charcoal/70"}`}>{status}</span>;
}

export function ComingSoon({ title, description, testid }) {
  return (
    <div className="text-center py-20 bg-[#F8F9FA] rounded-sm border border-dashed border-border" data-testid={testid}>
      <span className="inline-block text-xs font-700 tracking-[0.2em] uppercase text-gold bg-gold/15 px-3 py-1 rounded-sm mb-4">Coming Soon</span>
      <h3 className="font-display text-2xl font-600 text-charcoal mb-2">{title}</h3>
      <p className="text-olive max-w-md mx-auto">{description}</p>
    </div>
  );
}
